module.exports = __webpack_public_path__ + "img/top.d206db1c.png";